import React from 'react'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

// Style for the image component
const StyledImage = styled('img')(({ isSelected }) => ({
  border: isSelected ? '3px solid blue' : '3px solid transparent',
  cursor: 'pointer',
  width: '50px', // Adjust image size as needed
  height: '50px',
  objectFit: 'cover',
  transition: 'border 0.2s',
}))

const Image = ({ src, isSelected, onClick }) => {
  return (
    <Box onClick={onClick}>
      <StyledImage src={src} alt="selectable" isSelected={isSelected} />
    </Box>
  )
}

export default Image
